<template>
  <div class="Trainee-modal-overlay">
    <transition name="modal-expand">
      <div v-if="isVisible" class="Trainee-modal" @click.stop>
        <div class="modal-content">
          <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
          <div class="search-container">
            <h3 style="font-size: 1.5rem; margin-bottom: 10px;">Sign Off Tasks for Trainees</h3>

          </div>
          <div class="pagination-button-container">
            <div class="pagination-container">
              <button @click="toggleSelectAllVisibleTrainees" class="multi-sign-off-button">
                {{ areAllTasksSelected ? 'Deselect All' : 'Select All' }}
              </button>
            </div>
          </div>
          <div class="container-fluid">
            <div class="table-responsive">
              <table class="data-table-trainee">
                <thead>
                  <tr style="border-bottom: 2px solid black;">
                    <th style="border-right: 2px solid black;">
                      Task
                    </th>
                    <th :colspan="filteredTrainees.length">
                      Trainee
                    </th>
                  </tr>
                  <tr>
                    <th style="border-right: 2px solid black; min-width: 80px;">
                      ATA | Task No
                    </th>
                    <!-- <th style="width: 80px;">
                      P1
                    </th>
                    <th style="border-right: 2px solid black; width: 80px;">
                      P2
                    </th> -->
                    <th v-for="trainee in filteredTrainees" :key="trainee.user_id"
                      :class="{ 'locked-trainee-header': isTraineeLocked(trainee.user_id) }"
                      :title="isTraineeLocked(trainee.user_id) ? 'Tasks cannot be signed off for this trainee because their logbook has been locked.' : ''">
                      {{ trainee.first_name }} {{ trainee.last_name }}<br>
                      <small>ID: {{ trainee.user_id }}</small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="task in sortedTasks" :key="task.task_id">
                    <td :title="task.description" style="border-right: 2px solid black; width: 80px;">
                      {{ task.chapt_no }} | {{ task.task_no }}<br>
                    </td>
                    <!-- <td style="width: 80px;">
                      <input class="center-icons" type="checkbox" style="margin-left: 5px; margin-right: 5px;"
                        v-model="task.entry_P1" @change="handleP1P2Change(task, 'P1')" @click.stop />
                    </td>
                    <td style="border-right: 2px solid black; width: 80px;">
                      <input class="center-icons" type="checkbox" style="margin-left: 5px; margin-right: 5px;"
                        v-model="task.entry_P2" @change="handleP1P2Change(task, 'P2')" @click.stop />
                    </td> -->
                    <td v-for="trainee in filteredTrainees" :key="trainee.user_id + '-' + task.task_id" :class="[
                      getEntryStatusClass(getTraineeEntry(task, trainee)),
                      { 'locked-trainee-cell': isTraineeLocked(trainee.user_id) }
                    ]">
                      <div v-if="getTraineeEntry(task, trainee)">
                        <span v-if="getTraineeEntry(task, trainee).ins_so">
                          <strong>{{ getTraineeEntry(task, trainee).selected_date?.split(' ')[0] || '' }}<br>{{
                            getInstructorNameFromEntry(getTraineeEntry(task, trainee)) }}</strong>
                        </span>
                        <span
                          v-else-if="getTraineeEntry(task, trainee).enabled === 1 && !getTraineeEntry(task, trainee).completed">
                          <font-awesome-icon class="enabled-icon" :icon="['fas', 'hourglass-half']"
                            title="Task is assigned but not signed off by the trainee" />
                        </span>
                        <span v-else @click="toggleCompletedTaskCheckbox(trainee.user_id, task.task_id)">
                          <input class="center-icons" type="checkbox"
                            :value="{ user_id: trainee.user_id, task_id: task.task_id }"
                            :disabled="isTraineeLocked(trainee.user_id)" v-model="selectedCompletedTasks"
                            style="margin-left: 5px;" @click.stop />
                        </span>
                      </div>
                      <div v-else title="Task has not been assigned">
                        ❌
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="button-container">
            <button class="ins-close-button" @click="close()">Close</button>
            <button class="btn btn-primary rounded" @click="signOffTasks">
              {{ processing ? 'Processing...' : 'Sign Off' }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
  <ChooseSignOffDateModal v-if="showChooseSignOffDateModal" :task-id="currentTaskId" :logbook-id="logbookId"
    :logbookentryId="logbookentryId" :instructorId="instructorId" :signOffType="signOffType"
    @signOffDateSelected="handleSignOffDateSelected" @multiDateSelected="handleMultiSignOffDateSelected"
    @close="closeChooseSignOffDateModal">
  </ChooseSignOffDateModal>
  <signature-modal v-if="showSignatureModal" role="instructor" @close="closeSignatureModal"></signature-modal>
</template>

<script>
import axios from 'axios';
import ChooseSignOffDateModal from '@/components/Instructor/ChooseSignOffDateModal.vue';
import SignatureModal from '@/components/Examiner/SignatureModal.vue';

export default {
  name: 'SelectCompletedTraineesModal',
  components: {
    ChooseSignOffDateModal,
    SignatureModal,
  },
  props: {
    propTasks: {
      type: Array,
      required: true,
    },
    logbooks: {
      type: Array,
      required: true,
    },
    initialSelected: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      trainees: [],
      selectedTrainees: [],
      instructors: [],
      instructor: {},
      signatures: [],
      instructorId: parseInt(localStorage.getItem('user_id')),
      sortField: 'user_id',
      sortDirection: 'asc',
      searchQuery: '',
      sessionSearchQuery: '',
      currentPage: 1,
      perPage: 50,
      totalPages: 0,
      filteredTraineesLength: null,
      isVisible: false,
      selectAll: false,
      selectedCompletedTasks: [],
      processing: false,
      showChooseSignOffDateModal: false,
      showSignatureModal: false,
      signOffType: 'multi',
    };
  },
  computed: {
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      const end = this.startIndex + this.perPage;
      return end < this.filteredTraineesLength ? end : this.filteredTraineesLength;
    },
    filteredTrainees() {
      return this.computeFilteredTrainees();
    },
    sortedTasks() {
      const chapRegex = /^(\d+)([A-Za-z]*)$/;

      return [...this.propTasks].sort((a, b) => {
        const [, numA, suffixA] = (a.chapt_no || '').match(chapRegex) || [];
        const [, numB, suffixB] = (b.chapt_no || '').match(chapRegex) || [];

        const chapterComparison = Number(numA) - Number(numB);
        if (chapterComparison !== 0) return chapterComparison;

        const suffixComparison = (suffixA || '').localeCompare(suffixB || '');
        if (suffixComparison !== 0) return suffixComparison;

        const taskA = parseInt(a.task_no, 10);
        const taskB = parseInt(b.task_no, 10);

        return taskA - taskB;
      });
    },
    areAllTasksSelected() {
      const visibleEntries = [];

      // Loop through visible trainees & tasks
      this.filteredTrainees.forEach(trainee => {
        this.sortedTasks.forEach(task => {
          const entry = this.getTraineeEntry(task, trainee);
          if (!entry || (!entry.ins_so && !(entry.enabled === 1 && !entry.completed))) {
            // Only consider checkboxes that can be signed off
            visibleEntries.push({ user_id: trainee.user_id, task_id: task.task_id });
          }
        });
      });

      // Check if every visible entry is in selectedCompletedTasks
      return visibleEntries.every(entry =>
        this.selectedCompletedTasks.some(
          sel => sel.user_id === entry.user_id && sel.task_id === entry.task_id
        )
      );
    },
    isTraineeLocked() {
      return (traineeId) => {
        const logbook = this.logbooks.find(l => l.trainee_id === traineeId);
        return logbook ? logbook.locked === 1 : 0;
      };
    },
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1;
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    goBack(signature=false) {
      if (signature === true) {
        localStorage.removeItem('selectedProject');
      }
      this.$router.push({ name: 'InstructorHome' });
    },
    findSelectedSignatureForUser(userId) {
      return this.signatures.find(sig => sig.user_id === userId && sig.is_selected && sig.role === 'instructor') || null;
    },
    toggleCompletedTaskCheckbox(userId, taskId) {
      // build the object same as your checkbox v-model
      const obj = { user_id: userId, task_id: taskId };

      // find if it's already selected
      const index = this.selectedCompletedTasks.findIndex(
        (t) => t.user_id === userId && t.task_id === taskId
      );

      if (index > -1) {
        this.selectedCompletedTasks.splice(index, 1);
      } else {
        this.selectedCompletedTasks.push(obj);
      }
    },
    toggleSelectAllVisibleTrainees() {
      const visibleEntries = [];

      this.filteredTrainees.forEach(trainee => {
        const traineeLocked = this.isTraineeLocked(trainee.user_id);
        if (traineeLocked) return; // Skip if trainee is locked

        this.sortedTasks.forEach(task => {
          const entry = this.getTraineeEntry(task, trainee);
          if (!entry) return;
          if (entry.ins_so) return;
          if (entry.enabled === 1 && !entry.completed) return;
          visibleEntries.push({ user_id: trainee.user_id, task_id: task.task_id });
        });
      });

      // Deselect all visible
      if (this.areAllTasksSelected) {
        this.selectedCompletedTasks = this.selectedCompletedTasks.filter(
          sel =>
            !visibleEntries.some(
              entry => entry.user_id === sel.user_id && entry.task_id === sel.task_id
            )
        );
      } else {
        // Select all visible (add only missing ones)
        visibleEntries.forEach(entry => {
          const alreadySelected = this.selectedCompletedTasks.some(
            sel => sel.user_id === entry.user_id && sel.task_id === entry.task_id
          );
          if (!alreadySelected) {
            this.selectedCompletedTasks.push(entry);
          }
        });
      }
    },
    getEntryStatusClass(entry) {
      if (!entry) return '';
      if (entry.ins_so) {
        return 'entry-ins-so';
      } else if (entry.completed) {
        return 'entry-completed';
      } else if (entry.enabled === 1 && !entry.completed) {
        return 'entry-enabled';
      }
      return '';
    },
    getTraineeEntry(task, trainee) {
      return task.trainees.find(t => t.user_id === trainee.user_id)?.entry || null;
    },
    toggleCheckbox(userId) {
      const index = this.selectedTrainees.indexOf(userId);
      if (index > -1) {
        this.selectedTrainees.splice(index, 1);
      } else {
        this.selectedTrainees.push(userId);
      }
    },
    selectTrainees() {
      this.$emit('confirm', this.selectedTrainees);
      this.close();
    },
    sortBy(field) {
      if (this.sortField === field) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortDirection = 'asc';
      }

      this.trainees.sort((a, b) => {
        const valueA = a[field];
        const valueB = b[field];

        if (typeof valueA === 'number' && typeof valueB === 'number') {
          return (this.sortDirection === 'asc' ? 1 : -1) * (valueA - valueB);
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
          return (this.sortDirection === 'asc' ? 1 : -1) * valueA.localeCompare(valueB);
        } else {
          return 0;
        }
      });
    },
    getFieldArrow(field = 'user_id') {
      if (this.sortField === field) {
        return this.sortDirection === 'asc' ? '▲' : '▼';
      } else {
        return '';
      }
    },
    onPageChange(page) {
      this.currentPage = page;
    },
    calculateTotalPages() {
      this.computeFilteredTrainees();
      this.totalPages = Math.ceil(this.filteredTraineesLength / this.perPage);
    },
    computeFilteredTrainees() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;

      const filteredTrainees = this.trainees.filter((trainee) => {
        const fullName = (trainee.first_name + trainee.last_name || "").toLowerCase();
        const traineeMatch = fullName.includes(this.searchQuery.toLowerCase()) || this.searchQuery === '';

        return traineeMatch
      });

      console.log('filtered', filteredTrainees);
      this.filteredTraineesLength = filteredTrainees.length;
      console.log('filetered length', this.filteredTraineesLength);
      return filteredTrainees.slice(startIndex, endIndex);
    },
    // async handleP1P2Change(task, changed) {
    //   // Ensure mutual exclusivity
    //   if (changed === 'P1' && task.entry_P1) {
    //     task.entry_P2 = false;
    //   } else if (changed === 'P2' && task.entry_P2) {
    //     task.entry_P1 = false;
    //   }
    // },
    async signOffTasks() {
      this.processing = true;
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      const currentDate = new Date();
      const formattedDate = this.formatDate(currentDate);
      const checkedCount = this.selectedCompletedTasks.length;
      const selectedSig = this.findSelectedSignatureForUser(parseInt(this.instructorId));

      if (!selectedSig) {
        // Open the signature modal in place; closeSignatureModal resumes the sign-off once one is saved
        this.processing = false;
        this.showSignatureModal = true;
        return;
      }
      if (checkedCount === 0) {
        alert('No tasks selected.');
        this.processing = false;
        return;
      }

      // const invalidTasks = this.selectedCompletedTasks.filter(({ task_id }) => {
      //   const task = this.propTasks.find(t => t.task_id === task_id);
      //   return !task.entry_P1 && !task.entry_P2;
      // });

      // if (invalidTasks.length > 0) {
      //   alert('Please select either P1 or P2 for all selected tasks before signing off.');
      //   this.processing = false;
      //   return;
      // }

      const confirmed = window.confirm(
        `Are you sure you want to sign off ${checkedCount} task(s) for selected trainee(s)?`
      );

      if (!confirmed) {
        this.processing = false;
        return;
      }

      console.log('selectedCompleted', this.selectedCompletedTasks);
      const logbook_entries = this.selectedCompletedTasks.map(({ user_id, task_id }) => {
        const task = this.propTasks.find(t => t.task_id === task_id);
        const trainee = task?.trainees?.find(tr => tr.user_id === user_id);
        const logbook_id = trainee?.entry?.logbook_id;

        // if (!task.entry_P1 && !task.entry_P2) {
        //   alert('Please select either P1 or P2 for each task before signing off.');
        //   return;
        // }

        if (!logbook_id) {
          console.warn(`Missing logbook_id for user ${user_id}, task ${task_id}`);
        }

        return {
          logbook_id,
          task_id,
          instructor_id: this.instructorId,
          ins_so: formattedDate,
          ins_signature_id: selectedSig?.id || null,
          // entry_P1: !!task.entry_P1,
          // entry_P2: !!task.entry_P2,
        };
      }).filter(entry => entry.logbook_id);

      console.log('logbook_entries', logbook_entries);

      try {
        const response = await axios.post('/api/logbookentry/batch-update',
          { logbook_entries: logbook_entries },
          { headers });
        console.log('response', response);
        if (response.status === 200) {
          alert('Tasks successfully signed off for selected trainees!');
          this.selectedTasks = [];
          this.isAllTasksSelected = false;
        }
      } catch (error) {
        console.error('Error signing off tasks:', error);
        alert('There was an error signing off the tasks.');
      } finally {
        this.processing = false;
        console.log('closed');
        this.$emit('confirm');
      }
    },
    openChooseSignOffDateModal(task, type) {
      this.signOffType = type;

      if (type === 'multi') {
        // Multi sign-off mode (no specific task)
        this.currentTask = null;
        this.currentTaskId = null;
        this.logbookentryId = null;
      } else {
        // Single task sign-off
        this.currentTask = task;
        this.currentTaskId = task.task_id;
        this.logbookentryId = task.logbookentry_id;
      }

      this.showChooseSignOffDateModal = true;
    },
    closeChooseSignOffDateModal() {
      this.showChooseSignOffDateModal = false;
    },
    async handleMultiSignOffDateSelected(selectedDate) {
      const dateObj = this.formatDate(selectedDate);
      await this.signOffTasks(dateObj);
      this.showChooseSignOffDateModal = false;
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    async fetchInstructorData() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const instId = parseInt(localStorage.getItem('user_id'));

      try {
        const response = await axios.get(`/api/users`, { headers });
        const users = response.data;
        this.instructors = users.filter(user => Array.isArray(user.roles) && user.roles.includes('instructor'));
        this.instructor = this.instructors.find(user => user.user_id === instId);
      } catch (error) {
        console.error('There was an error fetching the instructors:', error);
      }
    },
    getInstructorNameFromEntry(entry) {
      if (!entry || !entry.instructor_id) return 'Unknown';

      const inst = this.instructors.find(i => i.user_id === entry.instructor_id);
      return inst ? `${inst.last_name}, ${inst.first_name}` : 'Unknown';
    },
    async closeSignatureModal() {
      this.showSignatureModal = false;
      // Refresh signatures (one may have just been added), then resume the sign-off
      await this.fetchSignatures();
      if (this.findSelectedSignatureForUser(parseInt(this.instructorId))) {
        this.signOffTasks();
      }
    },
    fetchSignatures() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      return axios.get(`/api/books`, { headers })
        .then(response => {
          const responseData = response.data;
          this.signatures = responseData;
        })
        .catch(error => {
          // Handle any errors that occurred during the request
          console.error('Error fetching signatures:', error);
        });
    },
  },
  async mounted() {
    this.isVisible = true;
    this.trainees = this.initialSelected;
    this.filteredTraineesLength = this.trainees.length;
    this.totalPages = Math.ceil(this.trainees.length / this.perPage);
    this.fetchInstructorData();
    this.fetchSignatures();
    console.log('propTasks', this.propTasks);
  }
};
</script>

<style scoped>
.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-body {
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.confirm-button,
.cancel-button {
  padding: 10px 15px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-button {
  background-color: #28a745;
  color: white;
}

.cancel-button {
  background-color: #dc3545;
  color: white;
}

.trainee-table {
  width: 100%;
  border-collapse: collapse;
}

.trainee-table th,
.trainee-table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.trainee-table th {
  background-color: #f4f4f4;
}

.Trainee-modal-overlay {
  position: fixed;
  top: 0px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.Trainee-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  max-width: 90vw;
  max-height: 94vh;
  min-width: max(90vw, 1000px);
  padding: 10px;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1002;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  padding: 15px;
}

.modal-title {
  text-align: center;
  margin-bottom: 20px;
}

.assessment-table {
  width: 90%;
  border-collapse: collapse;
  align-items: center;
  margin: 0 auto;
}

.assessment-table th,
.assessment-table td {
  border: 1px solid #ddd;
  padding: 3px;
  text-align: left;
  font-size: 14px;
}

.assessment-table thead th {
  background-color: #f2f2f2;
  font-size: 15px;
}

.signature-section {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.signature-item label {
  width: 40%;
  display: block;
  margin-bottom: 5px;
}

.signature-placeholder,
.date-placeholder {
  border: 1px solid #ddd;
  padding: 5px;
  min-height: 30px;
  /* Adjust as needed */
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin: 0px;
}

.ins-save-button {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  width: 100%;
  min-width: 90px;
  max-width: 100px;
}

.ins-submit-button {
  background-color: brown;
  border: 1px solid rgb(92, 23, 23);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  min-width: 100px;
  max-width: 120px;
  margin-right: 5%;
  height: 35px;
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 5%;
}

.ins-close-button:hover {
  background-color: #4d5358;
}

.ins-clear-button {
  background-color: #f0ac9c;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 0;
  width: 100%;
  min-width: 140px;
  max-width: 150px;
  border: 1px solid #c7715e;
}

.ins-save-button:disabled,
.ins-submit-button:disabled,
.ins-clear-button:disabled {
  background-color: rgb(216, 216, 216);
  cursor: not-allowed;
  color: grey
}

.ins-save-button:disabled:hover,
.ins-submit-button:disabled:hover,
.ins-clear-button:disabled:hover {
  background-color: rgb(216, 216, 216);
  color: grey
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.assessment-result {
  margin-left: 25%;
}

.task-performance {
  width: 50%;
  border-collapse: collapse;
  text-align: left;
  background-color: #f2f2f2;
  margin-left: 20px;
}

.task-performance th {
  /* Adjust the color to match your header background */
  font-weight: bold;
}


.task-performance input[type="text"] {
  width: 100%;
  border: none;
  padding: 4px;
  text-align: center;
  background-color: #f2f2f2;
}

.assessment-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
}


.signature-block {
  display: flex;
  flex-direction: column;
  margin-right: 70px;
}


.signature-table {
  width: 100%;
}

.signature-table td {
  padding: 4px;
  /* Adjust padding as needed */
  vertical-align: middle;
  /* Aligns content of <td> vertically in the middle */
}

.signature-table .signature {
  text-align: left;
  /* Aligns the text to the left */
}

.trainee-signature {
  text-align: left;
}

.signature-table input[type="text"],
.signature-table input[type="date"] {
  width: 100%;
  border: none;
  border-bottom: 1px solid black;
  border-radius: 0px;
  background-color: transparent;
  outline: none;
  height: 20px;
}

@media (max-width: 768px) {

  /* Adjust the max-width as needed for iPad or other tablet sizes */
  .Evaluation-modal {
    padding: 5px;
    font-size: 0.9em;
    /* Reduce font size */
  }

  /* Further adjustments for other elements */
}


#selectAllSatisfactory {
  margin-left: 5px;
  border: 1px solid rgb(206, 13, 13);
}

.signature-pad {
  border-bottom: 1px solid #000;
  border-radius: 5px;
}

.right {
  display: flex;
  justify-content: flex-end;
  margin-right: 5%;
}

/* Add this CSS to your stylesheet */
.signature-image-wrapper {
  position: relative;
  display: inline-block;
}

.signature-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: none;
  /* Prevents interaction with the overlay */
}

.disabled {
  opacity: 0.5;
  /* Optionally reduce opacity to indicate disabled state */
}

.assess-button {
  border: 1px solid #555c57;
  border-radius: 2px;
  background-color: #d6d6d6;
}

.assess-button:hover {
  background-color: rgb(180, 180, 180);
}

.assess-button:disabled:hover {
  cursor: not-allowed;
}

.pass-button {
  border: 1px solid #507458;
  border-radius: 2px;
  background-color: #b0e6bd;
  color: #075e1a;
}

.pass-button:hover {
  background-color: #82d896;
}

.fail-button {
  border: 1px solid #745050;
  border-radius: 2px;
  background-color: #e6b0b0;
  color: #7a0606;
}

.fail-button:hover {
  background-color: #d88282;
}

.in-progress-button {
  border: 1px solid #a06e36;
  border-radius: 2px;
  background-color: #e4d09c;
  color: #724400;
}

.in-progress-button:hover {
  background-color: #d8b382;
}

.missing-task {
  background-color: #fce2e4;
  /* Light red background for missing tasks */
}

span:hover {
  cursor: pointer;
  color: blue;
}

.pagination-container {
  display: flex;
  margin-left: 3%;
  justify-content: space-between;
}

.container-fluid {
  padding-top: 5px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.search-container {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  font-size: 16px;
  width: 100%;
}

button.btn {
  padding: 10px 10px;
  font-size: 16px;
  width: 180px;
  height: 40px;
  margin-top: 0%;
  margin-bottom: 0px;
  border: 1px solid rgb(0, 45, 63);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  float: right;
  margin-right: 30px;
}

button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

.heading h1 {
  padding-top: 30px;
  padding-bottom: 10px;
  text-align: center;
  padding-left: 3%;

}

.back-button {
  /* Adjust the right position as needed */
  width: 100px;
  border-radius: 5px;
  background-color: #c1e0bf;
  float: left;
  margin-left: 30px;
  border: 2px solid black;
  padding: 3px;
}

button:hover {
  background-color: #7c927a;
  transition: transform 0.2s, box-shadow 0.2s;
}

.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.pagination-info {
  font-size: 14px;
  color: #666;
  /* Adjust the color as needed */
  position: absolute;
  top: 100px;
  left: 50%;
  /* Center horizontally */
  transform: translateX(-50%);
  /* Center horizontally */
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /* smooth scroll on mobile */
  width: 100%;
  margin-bottom: 10px;
}

/* Data table styles */
.data-table-trainee {
  min-width: 99%;
  margin-left: 0.5%;
  margin-right: 0.5%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  margin-top: 0;
  align-items: left;
  margin-bottom: 30px;
  border-collapse: collapse;
}

.data-table-trainee th {
  border: 1px solid #000000bf;
  padding: 10px 5px;
  text-align: left;
  color: rgb(107, 107, 107);
  background-color: rgba(219, 219, 219, 0.804);
  margin-top: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
}

.data-table-trainee tbody tr:nth-child(odd) {
  background-color: white;
}

.data-table-trainee tbody tr:nth-child(even) {
  background-color: rgba(219, 219, 219, 0.804);
}


.data-table-trainee td {
  border: 1px solid #000000bf;
  padding: 10px 5px;
  text-align: left;
  font-weight: 500;
  margin-top: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
}

.data-table-trainee,
.data-table-trainee th,
.data-table-trainee td {
  border: 1px solid black;
}

.data-table-trainee th,
.data-table-trainee td {
  padding: 8px;
}

.data-table-trainee td.center-icons {
  text-align: center;
}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  /* Red color */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.delete-icon:hover {
  color: #a82222;
  /* Lighter red color on hover */
  cursor: pointer;
  transform: scale(1.1);
  /* Scale the icon on hover */
  /* You can also add a box-shadow or any other styles you prefer */
}

.entry-ins-so {
  background-color: #d4edda;
  /* Light green */
  color: #155724;
}

.entry-completed {
  background-color: #fff3cd;
  color: #856404;
}

.enabled-icon {
  color: rgb(110, 110, 110);
  margin-left: 3px;
  font-size: 14px;
}

.enabled-icon:hover {
  color: #4c4c4c;
  cursor: auto;
}

span {
  border: none;
}

span:hover {
  color: #242424;
  cursor: auto;
}

.multi-sign-off-button {
  font-size: 15px;
  border-radius: 5px;
  margin-right: 20px;
  width: 140px;
  height: 40px;
  border: 1px solid grey;
}

.multi-sign-off-button:hover {
  background-color: #bbbaba;
}

.locked-trainee-header {
  background-color: #ffdddd !important;
  border-bottom: 1px solid #ff8888 !important;
  color: rgb(138, 82, 82) !important;
}

.locked-trainee-cell {
  background-color: #ffcccc !important;
  border-color: #ff8888 !important;
  border-right: 1px solid black !important;
  color: rgb(138, 82, 82) !important;
}
</style>